import { createSagaAction } from '../../../../shared/sagas'
import { createReducer } from '../../../../shared/reducers'

// Constants
export const constants = {
  TARGETED_MONTHLY_VISITS_REPORT_GET_JOB_LIST: createSagaAction(
    'TARGETED_MONTHLY_VISITS_REPORT_GET_JOB_LIST'
  ),
  TARGETED_MONTHLY_VISITS_REPORT_GET_FULL_REPORT: createSagaAction(
    'TARGETED_MONTHLY_VISITS_REPORT_GET_FULL_REPORT'
  )
}

// Action Creators
export const actions = {
  targetedMonthlyVisitsReportGetJobList: ({ filters }) => ({
    type: constants.TARGETED_MONTHLY_VISITS_REPORT_GET_JOB_LIST.ACTION,
    filters
  }),
  targetedMonthlyVisitsReportGetFullReport: ({ filters }) => ({
    type: constants.TARGETED_MONTHLY_VISITS_REPORT_GET_FULL_REPORT.ACTION,
    filters
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.TARGETED_MONTHLY_VISITS_REPORT_GET_JOB_LIST.ACTION:
      return { ...state, error: null, loadingJobList: true }
    case constants.TARGETED_MONTHLY_VISITS_REPORT_GET_JOB_LIST.SUCCESS:
      return {
        ...state,
        error: null,
        loadingJobList: false,
        jobList: action.payload
      }

    case constants.TARGETED_MONTHLY_VISITS_REPORT_GET_FULL_REPORT.ACTION:
      return { ...state, error: null, loadingFullReport: true }
    case constants.TARGETED_MONTHLY_VISITS_REPORT_GET_FULL_REPORT.SUCCESS:
      return {
        ...state,
        error: null,
        loadingFullReport: false,
        fullReport: action.payload
      }

    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/reports/maintenance_dob/targetedMonthlyVisitsReportActions.js